import React from 'react'

export const defaultContext = {
  products: [],
  getSession: undefined,
  hideDialog: undefined,
  coupon: null,
  setCoupon: undefined,
  showDialog: undefined,
  loading: false
}

export const Context = React.createContext(defaultContext)
